export default {
  contract: '0xF7328B3a7297AEc868fdF7F11047D19b232F5BcC'
}
